import { StateCheckOut } from "../pages/checkoutPage/state";
import { apiGetUserInfoFromReceiptSource } from "../utils/api";
import { EVENTS, callEvent } from "../utils/event";
import { genEndPointGetParam, getParamUrl } from "../utils/url";
import { LocalStorage } from "./LocalStorage";

export class ReceiptSource {
  constructor(
    code,
    url,
    logoUrl,
    headerConfig,
    bodyConfig,
    btnCheckoutConfig,
    loginUrl,
  ) {
    this.code = code;
    this.url = url;
    this.logoUrl = logoUrl;
    /** @type {ThemeConfig} */
    this.headerConfig = headerConfig;
    /** @type {ThemeConfig} */
    this.bodyConfig = bodyConfig;
    /** @type {ThemeConfig} */
    this.btnCheckoutConfig = btnCheckoutConfig;
    this.loginUrl = loginUrl;
  }

  static fromApiObject(input) {
    if (input && typeof (input) === "object") {
      return new ReceiptSource(
        input.code,
        input.url,
        input.logo_url,
        ThemeConfig.fromApiObject(input.config?.header),
        ThemeConfig.fromApiObject(input.config?.body),
        ThemeConfig.fromApiObject(input.config?.checkout_button),
        input.config?.login_url,
      )
    }

    return new ReceiptSource();
  }

  static fromApiArray(input) {
    if (input && Array.isArray(input)) {
      return input.map(item => ReceiptSource.fromApiObject(item));
    }

    if (input && typeof (input) === "object") {
      return [ReceiptSource.fromApiObject(input)];
    }

    return [];
  }

  static handleShippingProvider(orderCode, onSuccess = () => { }) {
    apiGetUserInfoFromReceiptSource({ order_code: orderCode },
      function (data) {
        let seConfig = data?.data;
        if (seConfig) {
          seConfig = ReceiptSource.fromApiObject(seConfig);
          LocalStorage.setReceiptSource(seConfig);
          callEvent(EVENTS.SWITH_THEME, seConfig);
          typeof onSuccess === "function" && onSuccess();
        } else {
          LocalStorage.setReceiptSource(undefined);
        }
      }
    )
  }

  static login() {
    let receiptSource = LocalStorage.getReceiptSource();
    if (receiptSource) {
      const params = getParamUrl();
      params["order_code"] = StateCheckOut.orderCode;
      window.location.href = genEndPointGetParam("/s/se-login", params);
    }
  }
}

export class ThemeConfig {
  constructor(
    style,
    textStyle,
    imageStyle,
    text
  ) {
    this.style = style;
    this.textStyle = textStyle;
    this.imageStyle = imageStyle;
    this.text = text;
  }

  static fromApiObject(input) {
    if (input && typeof (input) === "object") {
      return new ThemeConfig(
        input.style,
        input.text_style,
        input.image_style,
        input.text
      )
    }

    return new ThemeConfig();
  }

  static fromApiArray(input) {
    if (input && Array.isArray(input)) {
      return input.map(item => ThemeConfig.fromApiObject(item));
    }

    if (input && typeof (input) === "object") {
      return [ThemeConfig.fromApiObject(input)];
    }

    return [];
  }
}